<template>
  <div>
    <audio preload="auto" loop id="audio" :src=music></audio>
    <v-row class="article-container">
      <v-col md="9" cols="12">
        <v-card class="article-wrapper">
          <!-- <iframe :src="this.txtUrl" frameborder="0" width="100%" height="120px" scrolling="auto"></iframe> -->
          <article
           id="write"
           class="article-content markdown-body"
        v-html="article.content"
            ref="article"
          />
        </v-card>
      </v-col>
    </v-row>


  </div>
</template>

<script>
    import Clipboard from "clipboard";
import { fetchArticles } from "../api";

    export default {
    created() {
      this.getArticle();
    },
    // destroyed() {
    //   this.clipboard.destroy();
    //   tocbot.destroy();
    // },
    data: function() {
      return {
          txtUrl: "https://www.baidu.com/",
        article: {
          nextArticle: {
            id: 0,
            articleCover: ""
          },
          lastArticle: {
            id: 0,
            articleCover: ""
          },
          recommendArticleList: [],
          newestArticleList: []
        },
        wordNum: "",
        readTime: "",
        commentType: 1,
        articleHref: window.location.href,
        clipboard: null,
        commentCount: 0,
          music:'',
          isPlay:'true',
          animat:'running'
      };
    },
    methods: {
        audioAutoPlay() {
            let audio = document.getElementById("audio");
            audio.play();
            document.removeEventListener("touchstart", this.audioAutoPlay);
        },
      getArticle() {
        const that = this;
        let number = window.location.href.replace(/^(.*[n])*.*(.|n)$/g, "$2")
        //查询文章
        fetchArticles(number).then(({ data }) => {
            this.music=data.backmusic;
          // document.title = data.data.articleTitle;
          //将markdown转换为Html
          this.markdownToHtml(data);
          this.$nextTick(() => {
            // 统计文章字数
            // this.wordNum = this.deleteHTMLTag(this.article.articleContent).length;
            // 计算阅读时间
            // this.readTime = Math.round(this.wordNum / 400) + "分钟";
            // 添加代码复制功能
            // this.clipboard = new Clipboard(".copy-btn");
            // this.clipboard.on("success", () => {
            //   this.$toast({ type: "success", message: "复制成功" });
            // });
            // 添加文章生成目录功能
            // let nodes = this.$refs.article.children;
            // if (nodes.length) {
            //   for (let i = 0; i < nodes.length; i++) {
            //     let node = nodes[i];
            //     let reg = /^H[1-4]{1}$/;
            //     if (reg.exec(node.tagName)) {
            //       node.id = i;
            //     }
            //   }
            // }
            // tocbot.init({
            //   tocSelector: "#toc", //要把目录添加元素位置，支持选择器
            //   contentSelector: ".article-content", //获取html的元素
            //   headingSelector: "h1, h2, h3", //要显示的id的目录
            //   hasInnerContainers: true,
            //   onClick: function(e) {
            //     e.preventDefault();
            //   }
            // });
            // 添加图片预览功能
            // const imgList = this.$refs.article.getElementsByTagName("img");
            // for (var i = 0; i < imgList.length; i++) {
            //   this.imgList.push(imgList[i].src);
            //   imgList[i].addEventListener("click", function(e) {
            //     that.previewImg(e.target.currentSrc);
              // });
            // }
          });
        });
      },
      like() {
        // 判断登录
        // if (!this.$store.state.userId) {
        //   this.$store.state.loginFlag = true;
        //   return false;
        // }
        // 发送请求
        // this.axios
        //   .post("/api/articles/" + this.article.id + "/like")
        //   .then(({ data }) => {
        //     if (data.flag) {
        //       //判断是否点赞
        //       if (
        //         this.$store.state.articleLikeSet.indexOf(this.article.id) != -1
        //       ) {
        //         this.$set(this.article, "likeCount", this.article.likeCount - 1);
        //       } else {
        //         this.$set(this.article, "likeCount", this.article.likeCount + 1);
        //       }
        //       this.$store.commit("articleLike", this.article.id);
        //     }
        //   });
      },
      markdownToHtml(article) {
       var md = require('markdown-it')({
          html: true,
          linkify: true,
          typographer: true,
          breaks: true,
       })


        const hljs = require("highlight.js");
        // const md = new MarkdownIt({

        //   highlight: function(str, lang) {
        //     // 当前时间加随机数生成唯一的id标识
        //     var d = new Date().getTime();
        //     if (
        //       window.performance &&
        //       typeof window.performance.now === "function"
        //     ) {
        //       d += performance.now();
        //     }
        //     const codeIndex = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        //       /[xy]/g,
        //       function(c) {
        //         var r = (d + Math.random() * 16) % 16 | 0;
        //         d = Math.floor(d / 16);
        //         return (c == "x" ? r : (r & 0x3) | 0x8).toString(16);
        //       }
        //     );
        //     // 复制功能主要使用的是 clipboard.js
        //     let html = `<button class="copy-btn iconfont iconfuzhi" type="button" data-clipboard-action="copy" data-clipboard-target="#copy${codeIndex}"></button>`;
        //     const linesLength = str.split(/\n/).length - 1;
        //     // 生成行号
        //     let linesNum = '<span aria-hidden="true" class="line-numbers-rows">';
        //     for (let index = 0; index < linesLength; index++) {
        //       linesNum = linesNum + "<span></span>";
        //     }
        //     linesNum += "</span>";
        //     if (lang == null) {
        //       lang = "java";
        //     }
        //     if (lang && hljs.getLanguage(lang)) {
        //       // highlight.js 高亮代码
        //       const preCode = hljs.highlight(lang, str, true).value;
        //       html = html + preCode;
        //       if (linesLength) {
        //         html += '<b class="name">' + lang + "</b>";
        //       }
        //       // 将代码包裹在 textarea 中，由于防止textarea渲染出现问题，这里将 "<" 用 "<" 代替，不影响复制功能
        //       return `<pre class="hljs"><code>${html}</code>${linesNum}</pre><textarea style="position: absolute;top: -9999px;left: -9999px;z-index: -9999;" id="copy${codeIndex}">${str.replace(
        //         /<\/textarea>/g,
        //         "</textarea>"
        //       )}</textarea>`;
        //     }
        //   }
        // });
        // 将markdown替换为html标签
        article.content = md.render(article.content);
        this.article = article;
      },
      // previewImg(img) {
      //   this.$imagePreview({
      //     images: this.imgList,
      //     index: this.imgList.indexOf(img)
      //   });
      // },
      // deleteHTMLTag(content) {
      //   return content
      //     .replace(/<\/?[^>]*>/g, "")
      //     .replace(/[|]*\n/, "")
      //     .replace(/&npsp;/gi, "");
      // },
      // getCommentCount(count) {
      //   this.commentCount = count;
      // }
    },
    computed: {
        // calHeight() {
        //     return (window.innerHeight - 100) + 'px';
        // }

      //   blogInfo() {
      //   return this.$store.state.blogInfo;
      // },
      // articleCover() {
      //   return (
      //     "background: url(" +
      //     this.article.articleCover +
      //     ") center center / cover no-repeat"
      //   );
      // },
      // isLike() {
      //   var articleLikeSet = this.$store.state.articleLikeSet;
      //   return articleLikeSet.indexOf(this.article.id) != -1
      //     ? "like-btn-active"
      //     : "like-btn";
      // },
      // isFull() {
      //   return function(id) {
      //     return id ? "post full" : "post";
      //   };
      // }
    },
        mounted() {
            var myAuto = document.getElementById('audio');

            var app = document.getElementById("app");
            myAuto.play();
            // 监听事件
            app.onclick=function(){
                myAuto.play();
            }
        },

    };
</script>

<style scoped>
  .banner:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .article-info i {
    font-size: 14px;
  }
  .article-info {
    font-size: 14px;
    line-height: 1.9;
    display: inline-block;
  }
  @media (min-width: 760px) {
    .banner {
      color: #eee !important;
    }
    .article-info span {
      font-size: 95%;
    }
    .article-info-container {
      position: absolute;
      bottom: 6.25rem;
      padding: 0 8%;
      width: 100%;
      text-align: center;
    }
    .second-line,
    .third-line {
      display: inline;
    }
    .article-title {
      font-size: 35px;
      margin: 20px 0 8px;
    }
    .pagination-post {
      display: flex;
    }
    .post {
      width: 50%;
    }
    .recommend-item {
      position: relative;
      display: inline-block;
      overflow: hidden;
      margin: 3px;
      width: calc(33.333% - 6px);
      height: 200px;
      background: #000;
      vertical-align: bottom;
    }
  }
  @media (max-width: 759px) {
    .banner {
      color: #eee !important;
      height: 360px;
    }
    .article-info span {
      font-size: 90%;
    }
    .separator:first-child {
      display: none;
    }
    .blog-container {
      margin: 322px 5px 0 5px;
    }
    .article-info-container {
      position: absolute;
      bottom: 1.3rem;
      padding: 0 5%;
      width: 100%;
      color: #eee;
      text-align: left;
    }
    .article-title {
      font-size: 1.5rem;
      margin-bottom: 0.4rem;
    }
    .post {
      width: 100%;
    }
    .pagination-post {
      display: block;
    }
    .recommend-item {
      position: relative;
      display: inline-block;
      overflow: hidden;
      margin: 3px;
      width: calc(100% - 4px);
      height: 150px;
      margin: 2px;
      background: #000;
      vertical-align: bottom;
    }
  }
  .article-operation {
    display: flex;
    align-items: center;
  }
  .article-category a {
    color: #fff !important;
  }
  .tag-container a {
    display: inline-block;
    margin: 0.5rem 0.5rem 0.5rem 0;
    padding: 0 0.75rem;
    width: fit-content;
    border: 1px solid #49b1f5;
    border-radius: 1rem;
    color: #49b1f5 !important;
    font-size: 12px;
    line-height: 2;
  }
  .tag-container a:hover {
    color: #fff !important;
    background: #49b1f5;
    transition: all 0.5s;
  }
  .aritcle-copyright {
    position: relative;
    margin-top: 40px;
    margin-bottom: 10px;
    font-size: 0.875rem;
    line-height: 2;
    padding: 0.625rem 1rem;
    border: 1px solid #eee;
  }
  .aritcle-copyright span {
    color: #49b1f5;
    font-weight: bold;
  }
  .aritcle-copyright a {
    text-decoration: underline !important;
    color: #99a9bf !important;
  }
  .aritcle-copyright:before {
    position: absolute;
    top: 0.7rem;
    right: 0.7rem;
    width: 1rem;
    height: 1rem;
    border-radius: 1rem;
    background: #49b1f5;
    content: "";
  }
  .aritcle-copyright:after {
    position: absolute;
    top: 0.95rem;
    right: 0.95rem;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 0.5em;
    background: #fff;
    content: "";
  }
  .article-reward {
    margin-top: 5rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .reward-btn {
    position: relative;
    display: inline-block;
    width: 100px;
    background: #49b1f5;
    margin: 0 1rem;
    color: #fff !important;
    text-align: center;
    line-height: 36px;
    font-size: 0.875rem;
  }
  .reward-btn:hover .reward-main {
    display: block;
  }
  .reward-main {
    display: none;
    position: absolute;
    bottom: 40px;
    left: 0;
    margin: 0;
    padding: 0 0 15px;
    width: 100%;
  }
  .reward-all {
    display: inline-block;
    margin: 0 0 0 -110px;
    padding: 20px 10px 8px !important;
    width: 320px;
    border-radius: 4px;
    background: #f5f5f5;
  }
  .reward-all:before {
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 100%;
    height: 20px;
    content: "";
  }
  .reward-all:after {
    content: "";
    position: absolute;
    right: 0;
    bottom: 2px;
    left: 0;
    margin: 0 auto;
    width: 0;
    height: 0;
    border-top: 13px solid #f5f5f5;
    border-right: 13px solid transparent;
    border-left: 13px solid transparent;
  }
  .reward-item {
    display: inline-block;
    padding: 0 8px;
    list-style-type: none;
  }
  .reward-img {
    width: 130px;
    height: 130px;
    display: block;
  }
  .reward-desc {
    margin: -5px 0;
    color: #858585;
    text-align: center;
  }
  .like-btn {
    display: inline-block;
    width: 100px;
    background: #969696;
    color: #fff !important;
    text-align: center;
    line-height: 36px;
    font-size: 0.875rem;
  }
  .like-btn-active {
    display: inline-block;
    width: 100px;
    background: #ec7259;
    color: #fff !important;
    text-align: center;
    line-height: 36px;
    font-size: 0.875rem;
  }
  .pagination-post {
    margin-top: 40px;
    overflow: hidden;
    width: 100%;
    background: #000;
  }
  .post {
    position: relative;
    height: 150px;
    overflow: hidden;
  }
  .post-info {
    position: absolute;
    top: 50%;
    padding: 20px 40px;
    width: 100%;
    transform: translate(0, -50%);
    line-height: 2;
    font-size: 14px;
  }
  .post-cover {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0.4;
    transition: all 0.6s;
    object-fit: cover;
  }
  .post a {
    position: relative;
    display: block;
    overflow: hidden;
    height: 150px;
  }
  .post:hover .post-cover {
    opacity: 0.8;
    transform: scale(1.1);
  }
  .label {
    font-size: 90%;
    color: #eee;
  }
  .post-title {
    font-weight: 500;
    color: #fff;
  }
  hr {
    position: relative;
    margin: 40px auto;
    border: 2px dashed #d2ebfd;
    width: calc(100% - 4px);
  }
  .full {
    width: 100% !important;
  }
  .right-container {
    padding: 20px 24px;
    font-size: 14px;
  }
  .right-title {
    display: flex;
    align-items: center;
    line-height: 2;
    font-size: 16.8px;
    margin-bottom: 6px;
  }
  .right-title i {
    font-weight: bold;
  }
  .recommend-container {
    margin-top: 40px;
  }
  .recommend-title {
    font-size: 20px;
    line-height: 2;
    font-weight: bold;
    margin-bottom: 5px;
  }
  .recommend-cover {
    width: 100%;
    height: 100%;
    opacity: 0.4;
    transition: all 0.6s;
    object-fit: cover;
  }
  .recommend-info {
    line-height: 2;
    color: #fff;
    position: absolute;
    top: 50%;
    padding: 0 20px;
    width: 100%;
    transform: translate(0, -50%);
    text-align: center;
    font-size: 14px;
  }
  .recommend-date {
    font-size: 90%;
  }
  .recommend-item:hover .recommend-cover {
    opacity: 0.8;
    transform: scale(1.1);
  }
  .article-item {
    display: flex;
    align-items: center;
    padding: 6px 0;
  }
  .article-item:first-child {
    padding-top: 0;
  }
  .article-item:last-child {
    padding-bottom: 0;
  }
  .article-item:not(:last-child) {
    border-bottom: 1px dashed #f5f5f5;
  }
  .article-item img {
    width: 100%;
    height: 100%;
    transition: all 0.6s;
    object-fit: cover;
  }
  .article-item img:hover {
    transform: scale(1.1);
  }
  .content {
    flex: 1;
    padding-left: 10px;
    word-break: break-all;
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
  }
  .content-cover {
    width: 58.8px;
    height: 58.8px;
    overflow: hidden;
  }
  .content-title a {
    transition: all 0.2s;
    font-size: 95%;
  }
  .content-title a:hover {
    color: #2ba1d1;
  }
  .content-time {
    color: #858585;
    font-size: 85%;
    line-height: 2;
  }
</style>

<style lang="scss">
  pre.hljs {
    color: #0d1117;
    background:#F5F5F5 !important;
    padding: 12px 2px 12px 40px !important;
    border-radius: 5px !important;
    position: relative;
    font-size: 14px !important;
    line-height: 22px !important;
    overflow: hidden !important;
    &:hover .copy-btn {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    code {
      display: block !important;
      margin: 0 10px !important;
      overflow-x: auto !important;
      &::-webkit-scrollbar {
        z-index: 11;
        width: 6px;
      }
      &::-webkit-scrollbar:horizontal {
        height: 6px;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 5px;
        width: 6px;
        background: #666;
      }
      &::-webkit-scrollbar-corner,
      &::-webkit-scrollbar-track {
        background: #1e1e1e;
      }
      &::-webkit-scrollbar-track-piece {
        background: #1e1e1e;
        width: 6px;
      }
    }
    .line-numbers-rows {
      position: absolute;
      pointer-events: none;
      top: 12px;
      bottom: 12px;
      left: 0;
      font-size: 100%;
      width: 40px;
      text-align: center;
      letter-spacing: -1px;
      border-right: 1px solid rgba(0, 0, 0, 0.66);
      user-select: none;
      counter-reset: linenumber;
      span {
        pointer-events: none;
        display: block;
        counter-increment: linenumber;
        &:before {
          content: counter(linenumber);
          color: #999;
          display: block;
          text-align: center;
        }
      }
    }
    b.name {
      position: absolute;
      top: 7px;
      right: 45px;
      z-index: 1;
      color: #999;
      pointer-events: none;
    }
    .copy-btn {
      position: absolute;
      top: 6px;
      right: 6px;
      z-index: 1;
      color: #ccc;
      background-color: #525252;
      border-radius: 6px;
      display: none;
      font-size: 14px;
      width: 32px;
      height: 24px;
      outline: none;
    }
  }
</style>
